import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { config } from 'src/app/config/api.config';
import { UpdateUser } from 'src/app/model/UpdateUser.model';
import { Login } from 'src/app/model/login.model';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css'],
})
export class EditPasswordComponent implements OnInit {
  user!: any;
  firstName!: string;
  lastName!: string;
  userId!: string;
  updatePasswordForm!: FormGroup;
  isnotValid: boolean = false;
  isPasswordMismatch: boolean = false;
  isSuccess: boolean = false;
  isServerError: boolean = false;
  email!: string;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.user = sessionStorage.getItem('user');
  }

  ngOnInit(): void {
    ////console.log('infos user:', this.user);
    //Recuperation de l'id de la personne connecte!
    this.email = JSON.parse(this.user).email;
    this.authService.getUserByEmail(this.email).subscribe((Response) => {
      this.userId = Response[0].id;
      this.firstName = Response[0].firstName;
      this.lastName = Response[0].lastName;
      //// //console.log(Response);
    });
    this.initForm();
  }
  onSubmitForm() {
    const formValue = this.updatePasswordForm.value;
    //// //console.log(formValue);

    //Creation de l'Objet UpdateUser
    const updateUser = new UpdateUser(
      this.email,
      this.email,
      formValue['newPassword'],
      this.firstName,
      this.lastName
    );

    //Check if actuelPassword is OK!
    const LoginInfo = new Login(this.email, formValue['actuelPassword']);

    if (formValue['newPassword'] === formValue['confirmNewPassword']) {
      this.authService.login(LoginInfo).subscribe((Response) => {
        //// //console.log(Response);
        if (Response.status == 200) {
          this.authService
            .updatePassword(this.userId, updateUser)
            .subscribe((data) => {
              if (data == 'OK') {
                this.isSuccess = true;

                setTimeout(() => {
                  this.isSuccess = false;
                  sessionStorage.clear();
                  window.location.href =
                    'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/logout?client_id=fode-client&post_logout_redirect_uri=' +
                    config.redirectURI;
                }, 5000);
              } else {
                this.isServerError = true;
                setTimeout(() => {
                  this.isServerError = false;
                  sessionStorage.clear();
                  window.location.href =
                    'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/logout?client_id=fode-client&post_logout_redirect_uri=' +
                    config.redirectURI;
                }, 5000);
              }
              //// //console.log('reponse apres update du mdp:', data);
            });
        } else {
          this.isnotValid = true;
          setTimeout(() => {
            this.isnotValid = false;
            sessionStorage.clear();
            window.location.href =
              'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/logout?client_id=fode-client&post_logout_redirect_uri=' +
              config.redirectURI;
          }, 5000);
        }
      });
    } else {
      this.isPasswordMismatch = true;
      setTimeout(() => {
        this.isPasswordMismatch = false;
      }, 5000);
    }
  }

  initForm() {
    this.updatePasswordForm = this.formBuilder.group({
      actuelPassword: ['', [Validators.required, Validators.min(8)]],
      newPassword: ['', [Validators.required, Validators.min(8)]],
      confirmNewPassword: ['', [Validators.required, Validators.min(8)]],
    });
  }
}
